/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DesignServiceBanner_user$ref = any;
type DiscoverContainer_viewer$ref = any;
type FolderContainer_viewer$ref = any;
type FoldersContainer_viewer$ref = any;
type FollowingContainer_viewer$ref = any;
type ItemsContainer_viewer$ref = any;
type ProjectsContainer_viewer$ref = any;
type Recommendations_trending$ref = any;
export type FavoritesContainer_viewer$ref = any;
export type FavoritesContainer_viewer = {
    readonly user?: {
        readonly isVerifiedTrade: boolean | null;
        readonly canShowSellerName: boolean | null;
        readonly " $fragmentRefs": DesignServiceBanner_user$ref;
    } | null;
    readonly " $fragmentRefs": Recommendations_trending$ref & DiscoverContainer_viewer$ref & FolderContainer_viewer$ref & FoldersContainer_viewer$ref & FollowingContainer_viewer$ref & ItemsContainer_viewer$ref & ProjectsContainer_viewer$ref;
    readonly " $refType": FavoritesContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FavoritesContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isDiscover",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isSinglePortfolio",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isFolders",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isFollowing",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isItems",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "isProjects",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isVerifiedTrade",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "canShowSellerName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "DesignServiceBanner_user",
                            "args": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "Recommendations_trending",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isDiscover",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DiscoverContainer_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isSinglePortfolio",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FolderContainer_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isFolders",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FoldersContainer_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isFollowing",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FollowingContainer_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isItems",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ItemsContainer_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isProjects",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectsContainer_viewer",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'b3e1a65de4490fc04df4cb090b9efc53';
export default node;
